import { PickSessionItem } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import {
  buildLicensePlateScanSet as buildModelLicensePlateScanSet,
  matchesLicensePlateScan as matchesModelLicensePlateScan,
  normalizeLicensePlateScan as normalizeModelLicensePlateScan,
} from "@redotech/redo-inventory-common/license-plate-scan";

// Some labels encode raw inventory_item.id while older labels encode ii_ ids.
export function matchesLicensePlateScan(
  item: Pick<PickSessionItem, "inventoryItemId">,
  scannedBarcode: string,
): boolean {
  return matchesModelLicensePlateScan(item, scannedBarcode);
}

export function buildLicensePlateScanSet(
  formattedIds: Iterable<string | null | undefined>,
): Set<string> {
  return buildModelLicensePlateScanSet(formattedIds);
}

export function normalizeLicensePlateScan(value: string): string | null {
  return normalizeModelLicensePlateScan(value);
}
